import React, {Component} from 'react';

import { Link } from "react-router-dom";

import { Responsive, Container, Grid, Image } from 'semantic-ui-react';
import CARING from './img/caring.png';
import YOUTUBE from './img/youtube.png';
import FACEBOOK from './img/find_us_on_fb.png';
import './footer.css';
const brandName = "Rotary Club Central";

class Footer extends Component {
  render() {
    return(
      <div className="footer">
        <Grid>
          <Grid.Row>
            <Grid.Column computer={2}>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={8} computer={8}>
              <Grid>
                <Grid.Row>
                  {/*<Grid.Column mobile={4} tablet={4} computer={4}>*/}
                  {/*  Terms & Conditions*/}
                  {/*</Grid.Column>*/}
                  <Grid.Column mobile={4} tablet={4} computer={4}>
                    <Link to={"/privacysecurity"}
                          className="footer-item">
                    Privacy & Security
                    </Link>
                  </Grid.Column>
                  <Grid.Column mobile={4} tablet={4} computer={4}
                             >
                  <a href='/contactus'
                     className="footer-item">
                    Contact Us
                    </a>
                  </Grid.Column>
                  <Grid.Column mobile={4} tablet={4} computer={4}>
                    <a href="https://www.facebook.com/hongkongrcc/" target={"_blank"}>
                      <Image style={{width: '100%', height: 'auto', alignSelf: 'center'}} src={FACEBOOK} className="facebook_img"/>
                    </a>
                  </Grid.Column>
                  {/*<Grid.Column mobile={4} tablet={4} computer={4}>*/}
                  {/*  Site Map*/}
                  {/*</Grid.Column>*/}
                </Grid.Row>
                {/*<Grid.Row>*/}
                {/*  <Grid.Column  mobile={4} tablet={6} computer={6}>*/}
                {/*  </Grid.Column>*/}
                {/*  /!*<Grid.Column  mobile={4} tablet={2} computer={2}>*!/*/}
                {/*  /!*  <Image src={YOUTUBE} className="youtube_img"/>*!/*/}
                {/*  /!*</Grid.Column>*!/*/}

                {/*  <Grid.Column  mobile={4} tablet={6} computer={6}>*/}
                {/*  </Grid.Column>*/}
                {/*</Grid.Row>*/}
                <Grid.Row>
                  <Grid.Column>
                    Registration & number. Certification of incorporation 2484431. Tax-exempt charity ref no. 91/15813
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
            <Grid.Column className="floating" mobile={16} tablet={4} computer={4}>
              <Image src={CARING} className="footerLogo" />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    )
  }

}

export default Footer;
